import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="font-display text-4xl italic mb-8 text-light-text dark:text-pure-white">
        Terms of Service
      </h1>

      <div className="prose dark:prose-invert font-body text-light-text dark:text-silver space-y-6">
        <p className="text-light-text-secondary dark:text-silver/80">
          Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
        </p>

        <section className="space-y-4">
          <h2 className="font-display text-2xl italic text-light-text dark:text-pure-white">
            1. Acceptance of Terms
          </h2>
          <p>
            By accessing and using Calendiary, you accept and agree to be bound by the terms and
            provisions of this agreement. If you do not agree to abide by the above, please do not
            use this service.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="font-display text-2xl italic text-light-text dark:text-pure-white">
            2. Description of Service
          </h2>
          <p>
            Calendiary is a medical appointment booking platform that connects patients with
            healthcare providers. We provide tools for scheduling appointments, managing medical
            practices, and facilitating healthcare communications.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="font-display text-2xl italic text-light-text dark:text-pure-white">
            3. User Accounts
          </h2>
          <p>
            You are responsible for maintaining the confidentiality of your account and password.
            You agree to accept responsibility for all activities that occur under your account.
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>You must provide accurate and complete registration information</li>
            <li>You must notify us immediately of any unauthorized use of your account</li>
            <li>We reserve the right to terminate accounts that violate these terms</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="font-display text-2xl italic text-light-text dark:text-pure-white">
            4. Healthcare Disclaimer
          </h2>
          <p>
            Calendiary is a scheduling platform only. We do not provide medical advice, diagnosis,
            or treatment. All medical decisions should be made in consultation with qualified
            healthcare providers.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="font-display text-2xl italic text-light-text dark:text-pure-white">
            5. User Conduct
          </h2>
          <p>Users agree not to:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Use the service for any unlawful purpose</li>
            <li>Impersonate any person or entity</li>
            <li>Interfere with the operation of the service</li>
            <li>Attempt to gain unauthorized access to any systems</li>
            <li>Post false or misleading information</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="font-display text-2xl italic text-light-text dark:text-pure-white">
            6. Intellectual Property
          </h2>
          <p>
            All content, features, and functionality of Calendiary are owned by us and are
            protected by international copyright, trademark, and other intellectual property laws.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="font-display text-2xl italic text-light-text dark:text-pure-white">
            7. Limitation of Liability
          </h2>
          <p>
            Calendiary shall not be liable for any indirect, incidental, special, consequential,
            or punitive damages resulting from your use of or inability to use the service.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="font-display text-2xl italic text-light-text dark:text-pure-white">
            8. Changes to Terms
          </h2>
          <p>
            We reserve the right to modify these terms at any time. We will notify users of any
            material changes by posting the new Terms of Service on this page.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="font-display text-2xl italic text-light-text dark:text-pure-white">
            9. Contact Information
          </h2>
          <p>
            If you have any questions about these Terms of Service, please contact us at{' '}
            <a href="mailto:support@calendiary.com" className="text-light-text dark:text-pure-white underline hover:opacity-80">
              support@calendiary.com
            </a>
          </p>
        </section>
      </div>

      <div className="mt-12 pt-8 border-t border-light-text/10 dark:border-silver/10">
        <Link
          to="/"
          className="inline-flex items-center gap-2 font-body text-sm text-light-text-secondary dark:text-silver/80 hover:text-light-text dark:hover:text-pure-white transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
          </svg>
          Back to Homepage
        </Link>
      </div>
    </div>
  );
};

export default TermsOfService;
